import { validateContactBatch, contactInvitationURL } from '/contacts-policy.mjs';
import { createContactReview } from '../ui/09-contact-review.mjs';

/** Wire the canonical contact policy into the browser review controller. */
export function createContacts(ctx, env = {}) {
  return createContactReview(ctx, { validateContactBatch, contactInvitationURL }, env);
}
